import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";
import { convertUTCtoIST } from "@/utils";
import { useDateRangeStore } from "./date-range-picker/use-date-range-store";
import { fetchAllPerformanceLogsOfEmployeeForAdminQueryOptions } from "@/config/queries/query-options";
import { ColumnDef } from "@tanstack/react-table";
import { PerformanceLog } from "./logs-table/schema";
import { getColumns } from "./logs-table/columns";
import { usePerformanceLogModal } from "./use-performance-log-modal";
import { DataTable } from "./logs-table/data-table";
import { DateRangePicker } from "./date-range-picker/date-range-picker2";

export const EmployeePerformanceLogsModal = () => {
  const { open, onOpenChange } = usePerformanceLogModal();

  const { empId } = useParams() as {
    empId: string;
  };

  const key = Cookies.get("key") as string;
  const { dateRange } = useDateRangeStore();

  // const startdate = dateRange?.from as Date;
  const startdate = convertUTCtoIST(
    new Date(
      new Date(new Date(dateRange?.from as Date).setHours(0)).setMinutes(0)
    )
  );
  const enddate = convertUTCtoIST(
    new Date(
      new Date(new Date(dateRange?.to as Date).setHours(23)).setMinutes(59)
    )
  );

  const { data, isPending, isFetching } = useQuery(
    fetchAllPerformanceLogsOfEmployeeForAdminQueryOptions(key, {
      employee: empId,
      startdate,
      enddate,
    })
  );

  // console.log("Data", data);

  const logsData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.log === undefined) {
      return [];
    }

    const result = data?.log?.map((t) => {
      return {
        id: t?._id,
        deduction: t?.deduction,
        addition: t?.addition || 0,
        reasonPositive: t?.reasonPositive,
        reasonNegative: t?.reasonNegative,
        createdAt: t?.createdAt,
        date: t?.date,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime()
    );
  }, [data, isPending, isFetching]);

  const columns = useMemo<ColumnDef<PerformanceLog, unknown>[]>(
    () => getColumns(),
    []
  );

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-7xl overflow-y-scroll max-h-[580px]">
          <DialogHeader>
            <DialogTitle>Employee Performance Logs</DialogTitle>
          </DialogHeader>

          <div className="flex items-center justify-end gap-3">
            <DateRangePicker />
          </div>

          <div className="mt-5">
            <DataTable data={logsData} columns={columns} />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
